/**
 * Constructs an avatar URL with workspace ID and cache-busting parameters
 * @param avatarUrl - The base avatar URL
 * @param workspaceId - Optional workspace ID (if not provided, will use current workspace from store)
 * @returns The avatar URL with proper parameters, or null if no avatar URL provided
 */
export const getAvatarUrl = (avatarUrl: string | null | undefined): string | null => {
  if (!avatarUrl) {
    return null;
  }

  try {
    const url = new URL(avatarUrl, window.location.origin);

    return url.toString();
  } catch (error) {
    console.error('Error constructing avatar URL:', error);
    return avatarUrl;
  }
};

/**
 * Hook version of getAvatarUrl that automatically uses current workspace from auth store
 * @param avatarUrl - The base avatar URL
 * @returns The avatar URL with proper parameters, or null if no avatar URL provided
 */
export const useAvatarUrl = (avatarUrl: string | null | undefined): string | null => {
  if (!avatarUrl) {
    return null;
  }

  try {
    const url = new URL(avatarUrl, window.location.origin);

    return url.toString();
  } catch (error) {
    console.error('Error constructing avatar URL:', error);
    return avatarUrl;
  }
};
